export class GridPaginator {
  pageIndex: number = 0;
  pageSize: number = 10;
}
